import { useTranslation } from 'react-i18next';

import { useGradeConfig } from '../../../hooks/useGradeConfig';
import { TurmaAutocomplete } from '../../molecules/TurmaAutocomplete';

/**
 * Barra de contexto da turma: Autocomplete de turma + nome do curso.
 *
 * Sem chips de período, contagem de disciplinas ou de vínculos (removidos pelo designer).
 */
export function ClassContextBar() {
  const { t } = useTranslation('gradeAttendanceConfig');
  const { classGroup, selectClass } = useGradeConfig();

  return (
    <div className="rounded-md border-hairline border-l-thick border-ctx-layout-border border-l-base-brand-600 bg-ctx-layout-surface px-xxxs py-mini shadow-level1">
      <div className="flex flex-wrap items-end gap-xxs">
        <div className="flex-1">
          <TurmaAutocomplete
            value={classGroup?.id ?? ''}
            selectedLabel={classGroup?.name ?? ''}
            onChange={selectClass}
            label={t('context.turmaLabel')}
            placeholder={t('context.turmaPlaceholder')}
          />
        </div>
      </div>
    </div>
  );
}
